

import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { GameDetails } from '../../Components/Game/GameDetails.jsx'
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx'
import { Game } from '../../Components/Game/Game.jsx'

import { Banners } from '../../Components/Banner/Banners.jsx'
import { MojCasino } from '../../Components/Casino/MojCasino.jsx'
import { BonusItem } from '../../Components/Bonuses/BonusItem.jsx'
import { MaratonPobjednici } from '../../Components/Casino/MaratonPobjednici.jsx'


import { MaratonHappyHour } from '../../Components/Casino/MaratonHappyHour.jsx'
import { MaratonHappyHourPobjednici } from '../../Components/Casino/MaratonHappyHourPobjednici.jsx'

import { LastManStanding } from '../../Components/Casino/LastManStanding.jsx'

import { MetaTags } from '../../Components/Layout/MetaTags.jsx'

export class BonusesLastManStanding extends React.Component {
    constructor(props) {
        super(props);
        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Last Man Standing', 'casino', this.props.user);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
    }

    render() {
        return <div >
            <MetaTags title="Bonusi - SuperSport CASINO" description="Last man standing bonus u SuperSport CASINU!" />
            <Header key="header" {...this.state} {...this.props}></Header>
            <div className='white-background'>
                <div className="banner ">
                    <section className="last-man-standing  last-man-standing-bonus-page banner--inner selected">
                        <div className="banner--content">
                            <div className="banner--bg-container">
                                <div className="banner--repeater" />
                                <div className="banner--repeater2">
                                </div>
                                <div className="banner--background" />
                            </div>
                            <div className="banner--foreground">
                                <div className="banner--image">
                                </div>

                                <div className="banner--text">
                                    <div className="as-inline-block center-verticaly">
                                        <span className="as-block text-white text-large  text-shadow" style={{ textTransform: "uppercase" }} >IZBORI SE ZA {casino.utils.switchKnToEur(10000) + ' ' + casino.utils.switchCurrencyKnToEur()}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div id="page-wrapper" className="max-width-70 margin-center no-padding-on-mobile" >
                    <div style={{ height: '62px', display: 'block' }} className='mobile-hidden'></div>
                    <div className="padding-sides-medium-2 border-top-small white-background">
                        {/* <h2 className='v4 margin-bottom-small'>Uskrsni bonus maraton</h2> */}

                        <div style={{ fontWeight: 'bold', color: '#4a5863' }}>
                            SuperSport ti predstavlja turnir „Last Man Standing“.<br /><br />
                                Svaki mjesec sudjeluj u novom ratu. Uključi se u sve borbe, preživi svaku od njih.
                                Izdrži sve borbe do kraja i sudjeluj u podjeli primamljivih nagrada.<br /><br />

                                Odigraj, budi uporan i osvoji.<br /><br />
                        </div>


                        <h2 className='v4 margin-bottom-small margin-top'>Kako do Last Man Standing utrke?</h2>
                        <div className="content-container-hh">

                            <div className="column">
                                <img src="content/images/assets/lastmanstanding/ic_how_to_1@2x.png" />
                                <h3>Prati naš Happy Hour</h3>
                                <p>
                                    Happy Hour se odigrava barem jednom dnevno, a nekad i više puta.
                                    Prati ga, sudjeluj u svakom i “preživi” do kraja mjeseca.
                                    </p>
                            </div>
                            <div className="column">
                                <img src="content/images/assets/lastmanstanding/ic_how_to_2@2x.png" />
                                <h3>Kvalificiraj se!</h3>
                                <p>
                                    Za preživljavanje borbe u prvoj polovici Happy Hour-a, odigraj barem 20 vrtnji s ulogom od minimalno {casino.utils.switchKnToEur(1) + ' ' + casino.utils.switchCurrencyKnToEur()}.
                                    Tako ćeš se kvalificirati za promociju Happy Hour-a.
                                    </p>
                            </div>
                            <div className="column">
                                <img src="content/images/assets/lastmanstanding/ic_how_to_3@2x.png" />
                                <h3>Preživi!</h3>
                                <p>
                                    Igraj u svim borbama tijekom mjeseca i sudjeluj u dijeljenju nagrade.
                                    Igraj i postani “Last Man Standing”!
                                    </p>
                            </div>


                        </div>



                    </div>

                    <LastManStanding {...this.props} hideHeader={true} extraClass="maraton2 white-background" />

                    <div className="text-center">

                        <a className="btn medium fill gray blue margin-top margin-bottom no-text-transform" target="_blank" href={`${casino.config.casinoCDNDocumentsUrl}/Pravila/LastManStanding2020.pdf?c=${casino.config.guiCacheVerzija}`}>
                            <span >Pravila igre</span> <span className="icon ico-expand-outline"></span>
                        </a>
                    </div>


                </div>
            </div>
            <GameDetails {...this.props} {...this.state} routePrefix="/promotions"></GameDetails>
            <ObavijestiCasino {...this.props}></ObavijestiCasino>
        </div>


    }
};
